import {ProductType} from '@features/sales/domain/models/product/product.model';
import {DiscountVO} from '@features/sales/domain/vo/discount.value-object';
import {AddonsVO} from '@features/sales/domain/vo/addon.value-object';
import {CartItemDTO} from "@features/sales/domain/models/cart/cart-item.model";

export class CartItem {
  readonly item: CartItemDTO['item'];
  readonly discount: DiscountVO;
  readonly addons: AddonsVO;
  readonly customUnitPrice?: number;

  private _quantity: number;

  constructor(dto: CartItemDTO) {
    this.item = dto.item;
    this._quantity = dto.quantity;
    this.customUnitPrice = dto.customUnitPrice;
    this.discount = new DiscountVO(dto.discount);
    this.addons = new AddonsVO(dto.additionalProduct);
  }

  get quantity(): number {
    return this._quantity;
  }

  get amount(): number {
    const basePrice = this.item.type === ProductType.COMPLEMENT
      ? 0
      : (this.customUnitPrice ?? this.item.price);

    const pricePerUnit = basePrice + this.addons.unitPriceIncrease;
    const subtotal = pricePerUnit * this._quantity;

    return this.discount.apply(subtotal);
  }

  matchesDTO(dto: CartItemDTO): boolean {
    if (this.item.id !== dto.item.id) {
      return false;
    }

    const currentUnitPrice = this.customUnitPrice ?? this.item.price;
    const dtoUnitPrice = dto.customUnitPrice ?? dto.item.price;

    if (currentUnitPrice !== dtoUnitPrice) {
      return false;
    }

    if (!DiscountVO.areDTOsEqual(this.discount.toDTO(), dto.discount)) {
      return false;
    }

    return AddonsVO.areDTOsEqual(this.addons.toDTO(), dto.additionalProduct);
  }

  addQuantity(quantity: number): void {
    if (quantity > 0) {
      this._quantity += quantity;
    }
  }

  toDTO(): CartItemDTO {
    return {
      item: this.item,
      quantity: this._quantity,
      amount: this.amount,
      customUnitPrice: this.customUnitPrice,
      discount: this.discount.toDTO(),
      additionalProduct: this.addons.toDTO(),
    };
  }
}
